import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const SpaceManagerLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceManagerContainer" */ './SpaceManager.tsx'))
			.SpaceManager,
});
